<div class="container" *ngIf="isTranslationLoaded">
  <div class="attempts-container">
    <div class="title-container">
      <div class="title">{{ 'reportingV2.ATTEMPTS_LABEL' | transloco }}</div>
      <div class="total">{{ tableData.length }} {{ 'reportingV2.TOTAL_LABEL' | transloco }}</div>
    </div>

    <qai-searchable-select [shape]="'rectangle'" [placeholder]="'reportingV2.USER_NAME' | transloco"
      [options]="userOptions" [searchable]="true" [searchPlaceholder]="'reportingV2.SEARCH_USERS' | transloco"
      [multiselect]="true" [value]="selectedUsers" (valueChange)="onUserFilterChange($event)"
      [scopedOptionsSelectionMode]="scopedOptionsSelectionModeUsers" [clearButton]="userClearOption">
    </qai-searchable-select>

    <qai-searchable-select [shape]="'rectangle'" [placeholder]="'reportingV2.SIMULATION' | transloco"
      [options]="simulationOptions" [searchable]="true"
      [searchPlaceholder]="'reportingV2.SEARCH_SIMULATIONS' | transloco" [value]="selectedSimulations"
      [multiselect]="true" (valueChange)="onSimulationFilterChange($event)" (itemSelected)="onSimulationSelected($event)"
      [scopedOptionsSelectionMode]="scopedOptionsSelectionModeSimulations" [clearButton]="simulationClearOption">
    </qai-searchable-select>

    <div class="date-filters">
      <qai-datepicker
        [endIcon]="'chevron-down'"
        [disabled]="false"
        [placeholder]="'reportingV2.START_DATE_LABEL' | transloco"
        [kind]="'default'"
        [shape]="'rectangle'"
        [size]="'medium'"
        [weight]="'regular'"
        [minDate]="minStartDate"
        [maxDate]="maxStartDate"
        [value]="startDate"
        (valueChange)="onDateChange('startDate', $event)"
      ></qai-datepicker>

      <qai-datepicker
        [endIcon]="'chevron-down'"
        [disabled]="false"
        [placeholder]="'reportingV2.END_DATE_LABEL' | transloco"
        [kind]="'default'"
        [shape]="'rectangle'"
        [size]="'medium'"
        [weight]="'regular'"
        [minDate]="minEndDate"
        [maxDate]="maxEndDate"
        [value]="endDate"
        (valueChange)="onDateChange('endDate', $event)"
      ></qai-datepicker>
    </div>

    <button class="icon-button" (click)="onDownloadIconClick()">
        <qai-icon [kind]="'download'" [size]="'20px'" />
    </button>
  </div>

  <div *ngIf="isLoading" class="loading-container">
    <qai-loading size="medium"></qai-loading>
  </div>

  <qai-table 
   class="attempts-table" 
   *ngIf="!isLoading"
   [headers]="headers"
   [data]="tableData"
   [showTimeInDateDisplay]="true"
   [pageSize]="pageSize"
   [currentPage]="currentPage"
   (cellClick)="onCellClick($event)"
   [showPagination]="showPagination"
   [initialSortColumn]="defaultSortColumn"
   [initialSortDirection]="defaultSortDirection"
   [noDataMessage]="'reportingV2.NO_ATTEMPTS' | transloco"
   (pageChanged)="pageChanged($event)"
   >
  </qai-table>

</div>